import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";
import WebsiteLogo from "../../assets/images/website.png";
import InstagramLogo from "../../assets/images/insta.png";
import FacebookLogo from "../../assets/images/fb.png";
import XLogo from "../../assets/images/x.png";

const platformLogos: { [key: string]: string } = {
  Instagram: InstagramLogo,
  Facebook: FacebookLogo,
  X: XLogo,
  Website: WebsiteLogo
};

const SocialMedia: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product?.socialMediaLinks || context.product.socialMediaLinks.length === 0) {
    return null;
  }

  const validLinks = context.product.socialMediaLinks.filter((link) => link.url.trim() !== "");
  if (validLinks.length === 0) {
    return null;
  }

  const formatURL = (url: string) => {
    return url.startsWith("http") ? url : `https://${url}`;
  };

  const headingColor = context.product.headingColor || "#000000";
  const headingFontStyle = context.product.headingFontStyle;

  return (
    <div className="w-full max-w-2xl mx-auto px-4 pb-4 font-mulish text-center">
      <h2
        style={{ letterSpacing: "0.01em", color: headingColor, fontFamily: headingFontStyle }}
        className="text-base font-bold text-gray-900 leading-tight pb-2"
      >
        Follow Us
      </h2>

      <div className="flex justify-center space-x-5 mt-2">
        {validLinks.map((link, index) => {
          const logo = platformLogos[link.platform];
          if (!logo) return null;

          return (
            <a key={index} href={formatURL(link.url)} target="_blank" rel="noopener noreferrer">
              <img src={logo} alt={link.platform} className="w-8 h-8" />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SocialMedia;
